import React from 'react';
import { Box, Typography, Card, CardContent, styled } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

import CallofDuty from '../static/img/news/img_callofduty.avif';
import Fortnite from '../static/img/news/img_fortnite.avif';
import Valorant from '../static/img/news/img_valorant.avif';
import Freefire from '../static/img/news/img_freefire.avif';
import Minecraft from '../static/img/news/img_minecraft.avif';
import Pubg from '../static/img/news/img_pubg.avif';

const NewsContainer = styled(Box)(({ theme }) => ({
  padding: '16px',
}));

const SectionHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '16px',
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontFamily: "'Poppins', sans-serif",
  fontSize: '18px',
  fontWeight: '600',
  color: '#FFFFFF',
}));

const ViewAllText = styled(Typography)(({ theme }) => ({
  fontFamily: "'Poppins', sans-serif",
  fontSize: '14px',
  fontWeight: '500',
  color: '#FAAE1C',
  cursor: 'pointer',
  '&:hover': {
    textDecoration: 'underline',
  },
}));


const NewsCard = styled(Box)(({ theme }) => ({
  minWidth: '240px',
  maxWidth: '240px',
  cursor: 'pointer',
  textAlign: 'center',
}));

const NewsImage = styled('img')(({ theme }) => ({
  width: '220px',
  height: '124px',
  borderRadius: '12px',
  objectFit: 'cover',
  marginBottom: '8px',
}));

const GameName = styled(Typography)(({ theme }) => ({
  fontFamily: "'Poppins', sans-serif",
  fontSize: '12px',
  fontWeight: '500',
  color: '#FFFFFF',
  textTransform: 'capitalize',
}));

const NewsType = styled(Typography)(({ theme }) => ({
  fontFamily: "'Poppins', sans-serif",
  fontSize: '11px',
  fontWeight: '400',
  color: '#888888',
  textTransform: 'uppercase',
  marginBottom: '4px',
}));

function GamezNews({ games }) {
  const navigate = useNavigate();

  const gameImages = {
    'Call of Duty': CallofDuty,
    'Valorant': Valorant,
    'PUBG': Pubg,
    'Fortnite': Fortnite,
    'Freefire': Freefire,
    'Minecraft': Minecraft,
  };

  const newsData = (games || []).map((game, index) => ({
    id: game.uuid || index,
    title: `Latest ${game.name} News`,
    type: "news",
    gameName: game.name,
    gameUuid: game.uuid,
    image: gameImages[game.name],
    content: `Stay updated with the latest ${game.name} news and updates`,
    rating: 4.0
  }));

  const handleNewsClick = (newsItem) => {
    const formattedGameName = newsItem.gameName.toLowerCase().replace(/\s+/g, '-');
    navigate(`/news/${formattedGameName}`);
  };

  const handleViewAll = () => {
    navigate('/news');
  };

  return (
    <NewsContainer>
      <SectionHeader>
        <SectionTitle>News</SectionTitle>
        <ViewAllText onClick={handleViewAll}>View All</ViewAllText>
      </SectionHeader>
      
      <Swiper
        spaceBetween={8}
        slidesPerView="auto"
        freeMode={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        style={{ paddingBottom: '8px' }}
      >
        {newsData.map((newsItem) => (
          <SwiperSlide key={newsItem.id} style={{ width: 'auto' }}>
            <NewsCard onClick={() => handleNewsClick(newsItem)}>
              <NewsImage
                src={gameImages[newsItem.gameName]}
                alt={newsItem.gameName}
              />
              <GameName>{newsItem.gameName}</GameName>
            </NewsCard>
          </SwiperSlide>
        ))}
      </Swiper>
    </NewsContainer>
  );
}

export default GamezNews;